import React from "react";
import styles from "../AssistantTestModule.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { PlusIcon } from "@radix-ui/react-icons";
import { PenIcon } from "../../../assets/icons/PenIcon";
import { TrashIcon } from "../../../assets/icons/TrashIcon";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateAssistant } from "../../../store/slices/assistantSlice";

export const Header = ({ assistantName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { activeAssistant } = useSelector((state) => state?.assistant);

  const [section] = pathname.split("/").filter(Boolean);

  const handleGoToUpdateAssistants = () => {
    dispatch(setUpdateAssistant(activeAssistant));
    navigate(`/${section}`, { state: { fromEditButton: true } });
  };

  return (
    <div className={styles.headerRow}>
      <h1 className={styles.title}>{assistantName}</h1>
      <div className={styles.actionsBtn}>
        <button
          className={`${styles.active} ${styles.addNew}`}
          onClick={() =>
            navigate(`/${section}/new`, { state: { fromTestScreen: true } })
          }
        >
          <PlusIcon width={16} height={16} color="white" />
        </button>
        <button
          className={`${styles.active} ${styles.edit}`}
          onClick={handleGoToUpdateAssistants}
        >
          <PenIcon size={12} fill={"white"} />
        </button>
        <button className={`${styles.active} ${styles.delete}`}>
          <TrashIcon width={15} height={15} fill={"white"} />
        </button>
      </div>
    </div>
  );
};
